import { capitalizeAllIfLower, formatAddressToString, formatDate, getPlaceAddress } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { compose, prop, propOr } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import CustomFields from './CustomFields'
import Documents from './Documents'
import LabelValue from '../../../../components/pdf/LabelValue'
import StatusReasonLabelValue from './StatusReasonLabelValue'
import { incrementCheckout, shouldIncrementCheckout } from '../../../../utils/helpers/serviceOrder'
import MarkdownPresentation from '../../../../components/pdf/Markdown'

const Overview = ({ serviceOrder }) => {
  const { t } = useTranslation('serviceOrders')
  const description = prop('description', serviceOrder)
  const checklistName = !!serviceOrder.name && capitalizeAllIfLower(serviceOrder.checklist?.name)
  const place = propOr({}, 'place', serviceOrder)
  const serviceOrderAddress = compose(formatAddressToString, propOr({}, 'address'))(serviceOrder)

  const placeAddress = compose(formatAddressToString, getPlaceAddress)(place)
  const finalAddress = serviceOrderAddress || placeAddress
  const checkInTime = compose(formatDate('DD/MM/YYYY HH:mm'), propOr('', 'startDate'))(serviceOrder)
  let checkOutTime = propOr('', 'endDate', serviceOrder)
  checkOutTime = shouldIncrementCheckout(serviceOrder)
    ? compose(formatDate('DD/MM/YYYY HH:mm'), incrementCheckout)(checkOutTime)
    : formatDate('DD/MM/YYYY HH:mm', checkOutTime)
  const hideCheckinAndCheckout = useSessionPermission('hideCheckinAndCheckout')

  return (
    <div>
      {checklistName && <LabelValue label={t('show.checklist')} value={checklistName} />}
      {serviceOrder.place && <LabelValue label={t('bulkEdit.fields.place')} value={place.resume + ' - ' + place.name} />}
      {serviceOrder.asset && <LabelValue label={t('show.asset')} value={serviceOrder.asset.name} />}
      {description && (
        <LabelValue
          plainValue
          label={t('fields.notes')}
          value={<MarkdownPresentation value={description} align="right" fontFamily="system-ui" />}
        />
      )}
      {!!finalAddress && <LabelValue label={t('show.address')} value={finalAddress} />}

      {!hideCheckinAndCheckout && <LabelValue label={t('fields.checkIn')} value={checkInTime} />}
      {!hideCheckinAndCheckout && <LabelValue label={t('fields.checkOut')} value={checkOutTime} />}

      <StatusReasonLabelValue serviceOrder={serviceOrder} />
      <LabelValue label={t('interpolations.groups.activity')} value={serviceOrder.yearlyId} />
      <CustomFields serviceOrder={serviceOrder} />
      <Documents serviceOrder={serviceOrder} />
    </div>
  )
}

export default Overview
